export function buildCognitoAuthorizeUrl(identityProvider: string): string {
    const cognitoDomain = import.meta.env.VITE_COGNITO_DOMAIN?.trim();
    const cognitoClientId = import.meta.env.VITE_COGNITO_CLIENT_ID?.trim();

    if (!cognitoDomain || !cognitoClientId) {
        const missingVariables = [!cognitoDomain ? "VITE_COGNITO_DOMAIN" : null, !cognitoClientId ? "VITE_COGNITO_CLIENT_ID" : null].filter(Boolean).join(", ");

        throw new Error(`Missing required Cognito SSO environment variable(s): ${missingVariables}`);
    }

    const redirectUri = `${window.location.origin}${import.meta.env.BASE_URL}sso/callback`;
    const normalizedDomain = cognitoDomain.endsWith("/") ? cognitoDomain.slice(0, -1) : cognitoDomain;

    return `${normalizedDomain}/oauth2/authorize?identity_provider=${encodeURIComponent(identityProvider)}&redirect_uri=${encodeURIComponent(redirectUri)}&response_type=code&client_id=${encodeURIComponent(cognitoClientId)}&scope=openid+email+profile`;
}
